module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-3224ab0f0f2a271340f111335c3aeb6b.svg";